import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
    POLYGON_MAP,
    POLYGON_OBSTACLE,
} from 'common/components/segment/constants';

import * as actions from '../actions';
import * as selectors from '../selectors';

import { ImageEditForm, ObstacleEditForm, SegmentEditForm } from './forms';

const SegmentEditCard = ({
    commercialOfferId,
    updateSegment,
    initialValues,
    mapRef,
    onCloseDrawer,
    resetForm,
    sxBox,
}) => {
    const escFunction = (event) => {
        if (event.key === 'Escape') resetForm();
    };

    useEffect(() => {
        document.addEventListener('keydown', escFunction, false);

        return () => {
            document.removeEventListener('keydown', escFunction, false);
        };
    }, []);

    if (initialValues.type === POLYGON_OBSTACLE) {
        return (
            <ObstacleEditForm
                {...{
                    commercialOfferId,
                    initialValues,
                    mapRef,
                    onCloseDrawer,
                    resetForm,
                    sxBox,
                    updateSegment,
                }}
            />
        );
    }

    if (initialValues.type === POLYGON_MAP) {
        return (
            <ImageEditForm
                {...{
                    commercialOfferId,
                    initialValues,
                    mapRef,
                    onCloseDrawer,
                    resetForm,
                    sxBox,
                    updateSegment,
                }}
            />
        );
    }

    return (
        <SegmentEditForm
            {...{
                commercialOfferId,
                initialValues,
                mapRef,
                onCloseDrawer,
                resetForm,
                sxBox,
                updateSegment,
            }}
        />
    );
};

const mapStateToProps = createStructuredSelector({
    initialValues: selectors.getInitialValues,
});

const mapDispatchToProps = (dispatch) => ({
    resetForm: () => dispatch(actions.resetForm()),
    updateSegment: (config) => dispatch(actions.updateSegment(config)),
});

SegmentEditCard.propTypes = {
    commercialOfferId: PropTypes.string,
    initialValues: PropTypes.object,
    mapRef: PropTypes.object,
    onCloseDrawer: PropTypes.func,
    resetForm: PropTypes.func,
    sxBox: PropTypes.object,
    updateSegment: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SegmentEditCard);
